var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.568,
    height: 14.813,
    viewBox: "0 0 8.568 14.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.24,8.193,2,14.437a1.262,1.262,0,0,1-.845.376,1.157,1.157,0,0,1-.8-.376,1.081,1.081,0,0,1,0-1.6L5.8,7.395.352,1.948a1.081,1.081,0,0,1,0-1.6A1.135,1.135,0,0,1,2,.352L8.24,6.6a1.1,1.1,0,0,1,.329.8A1.03,1.03,0,0,1,8.24,8.193Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.c9fd00c042c02db508f9e524c47adb2b.svg";
export { ForwardRef as ReactComponent };